<template>
<div class="chapter">
<div class="inner_page">
<p class="thl2"><span class="orange3">INTRODUCTION</span></p>
<p class="normalt-a">This sampler showcases three beautiful afghan projects to crochet from <i>Comfort Knitting &amp; Crochet: Afghans</i> by Norah Gaughan, Margery Winter, and the Berroco Design Team (published by STC Craft/Melanie FalickBooks, an imprint of Abrams). Fish Ripples is a delightful baby blanket. Marrakesh and Serpentine look beautiful in bedrooms and living rooms alike. We hope that you will enjoy making them and that they will bring warmth and good feelings into your home.</p>
<p class="img_center"><img alt="img" src="images/page_001.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3_Introduction.vue?add3aa2e